import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../button/Button";

interface EventEHRConfirmationDialogProps {
  open: boolean;
  alertTitle?: string;
  // Accepts a node (not just a string) so callers can render multi-line bodies.
  alertDescription?: React.ReactNode;
  submitButtonTitle?: string;
  cancelButtonTitle?: string;
  handleClose: (action: any) => void;
  // Optional sizing for the dialog paper. Default (undefined) leaves every
  // existing usage exactly as-is; the broadcast modal passes a fixed width so
  // it doesn't resize with the message length.
  paperSx?: object;
}

export default function EventEHRConfirmationDialog({
  open,
  alertTitle,
  submitButtonTitle,
  cancelButtonTitle,
  alertDescription,
  handleClose,
  paperSx,
}: EventEHRConfirmationDialogProps) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        hideBackdrop={false}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose("close");
          }
        }}
        PaperProps={paperSx ? { sx: paperSx } : undefined}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {alertTitle && (
          <DialogTitle id="alert-dialog-title" sx={{ fontFamily: "inter" }}>
            {alertTitle}
          </DialogTitle>
        )}
        <DialogContent>
          {alertDescription && (
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontFamily: "inter" }}
            >
              {alertDescription}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions sx={{ pb: "20px", pr: "20px" }}>
          {cancelButtonTitle && (
            <Button
              type="submit"
              label={cancelButtonTitle}
              variant="outlined"
              onClickCb={() => handleClose("close")}
              style={{
                padding: "8px 55px",
                fontSize: "16px",
              }}
            />
          )}
          {submitButtonTitle && (
            <Button
              type="submit"
              label={submitButtonTitle}
              variant="contained"
              onClickCb={() => handleClose("submit")}
              style={{
                padding: "8px 55px",
                fontSize: "16px",
              }}
            />
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
